import './QuestionForm.css'

import { FC, useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useClickOutside } from '../../hooks/useClickOutside'
import { analytics } from '../../utils/analytics'
import { AnimatedSpinner } from '../AnimatedSpinner'
import { IQuestionFormProps } from './QuestionForm'
import { SuggestedCompanions } from './SuggestedCompanionsList'
import Suggestions from './Suggestions'

export const QuestionFormDesktop: FC<IQuestionFormProps> = ({
  question,
  handleAskQuestion,
  clearForm,
  onChange,
  isDisabled,
  suggestedCompanions,
  isFetching,
  showSuggestions,
  onFocus,
}) => {
  const [isEditMode, setIsEditMode] = useState(false)

  const location = useLocation()

  useEffect(() => {
    setIsEditMode(false)
  }, [location.pathname])

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (showSuggestions) {
      setIsEditMode(true)
    }
  }, [showSuggestions])

  useClickOutside(inputRef, e => {
    const anchor = (e.target as HTMLElement).closest('a')
    if (anchor) return
    setIsEditMode(false)
  })

  const submitQuery = () => {
    setIsEditMode(false)
    handleAskQuestion()
    inputRef.current?.blur()
    analytics.logEvent('watch_session_clicked', {
      source: 'search',
    })
  }
  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.preventDefault()
    e.stopPropagation()
    if (e.key === 'Enter' && question) {
      submitQuery()
    }
  }

  const onkeydown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation()
  }

  const handleFocus = () => {
    onFocus()
    setIsEditMode(true)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e)
  }
  return (
    <div className="fixed bottom-0  w-full right-0 overflow-hidden z-50 flex items-center justify-center py-8 px-4 pointer-events-none question-form">
      <div className="flex flex-col  p-2 shadow-md tc-mv-blur rounded-regular pointer-events-auto w-full max-w-[70%] lg:max-w-[60%]">
        {!!suggestedCompanions?.length && isEditMode && (
          <SuggestedCompanions companions={suggestedCompanions} />
        )}
        <div className="flex gap-2 w-full">
          <div className="relative w-full">
            <input
              data-testid="question-input-desktop"
              className="pl-4 pr-8 w-full tc-mv-question-field  h-10 text-white dark:text-white rounded-full"
              value={question}
              onChange={handleChange}
              onKeyUp={handleKeyUp}
              onKeyDown={onkeydown}
              placeholder="Ask a question or find an expert"
              onFocus={handleFocus}
              ref={inputRef}
            />
            {question && (
              <button
                onClick={clearForm}
                className="absolute right-3 top-0 h-full flex items-center justify-center text-white opacity-80 hover:opacity-100"
                data-testid="clear-question-button"
              >
                {isFetching ? (
                  <AnimatedSpinner />
                ) : (
                  <i className="fa-solid fa-xmark text-xl" />
                )}
              </button>
            )}
          </div>
          <button
            className="h-10 w-10 min-w-10 flex items-center justify-center text-white font-medium tc-mv-blur align-middle rounded-full border-0 disabled:opacity-50"
            onClick={submitQuery}
            disabled={isDisabled}
            data-testid="submit-question-button"
          >
            <i className="fa-solid fa-arrow-up text-lg" />
          </button>
        </div>
        <div className="max-w-full">
          <Suggestions onClick={handleAskQuestion} />
        </div>
      </div>
    </div>
  )
}

export default QuestionFormDesktop
